//(start and edge of div and expands to fill)
//TODO: break up into w/hit nav and w/out -- eg one has a hit counter, other no

require('./searchBar.less');

var Marionette = require('marionette'),
     _ = require('underscore'),
      Backbone = require('backbone'),
    util = require('../../FV/util'); /* want for IE8 detection */

require('extendJQuery'); //(for unselectable, selectAll)
require('jqHighlight');


var defaults = {

    includeNAV: false,
    includeGrep: false, //(TODO: only allowed if includeNAV)

    startInGrepMode: false,

    keyUp: null, //if not in grep mode, called, otherwise, onAfterKeyUpInGrepMode is called if it is provided
    onAfterKeyUpInGrepMode: null,
    onAfterHighlightActiveHit: null, //use instead of keyUp if includeNAV

    preCollapse: null,
    onAfterFocus: null,
    onToggleGrep: null,

    allowCollapse: true,

    originalWidth: 0, //really a dummy width, now controlled by min-width in css but need val to toggle back to ('can't co below the min-width)
    $domToHighlight: null,

    TIMER_DELAY: 500,

    placeHolder: 'Search',
    initialSearchTxt: null,

    stretchToContainer: false //when true, input take up 100% of parent, essentially turning off the expand/contract functionality; also needs to set originalWidth

};

var keyUpTimer = null;

module.exports = Marionette.ItemView.extend({
    className: 'searchWidget',
    template: require('./searchBar.hbs'),
    initialize: function(options) {
        _.extend(this, defaults, _.pick( options, _.keys(defaults)) );
        this.stretchToContainer && (this.originalWidth = '100%');
        if (this.includeNAV) this._initNAVSection( this.options.$searchContainer );
    },
    _initNAVSection: function($searchContainer) {
        _.extend( this, {
            $domToHighlight: $searchContainer,
            searchUI: new SearchHitsUIModel( [], {
                $domElementsToSearch: $searchContainer
            })
        });
        this.listenTo(this.searchUI, 'changeHit', this.activeHitChangeCB);
        this.includeGrep && this.listenTo(this.searchUI, 'change:grepMode', this.grepModeToggled);
    },
    ui: {
        searchBar:            '.sb-input',
        searchCancelBtn:      '.search-cancel',
        currentHit:           '.currentHit',
        totalHits:            '.totalHits',
        nextBtn:              '.sbNext',
        prevBtn:              '.sbPrev',
        navWr:                '.sbNAV',
        grepBtn:              '.sbToggleGrep'
    },
    events: {
        'focus @ui.searchBar':        'searchBarFocused',
        'blur  @ui.searchBar':        'searchBarBlurred',
        'click @ui.searchCancelBtn':  'collapseIfAllowed',
        'mousedown @ui.nextBtn':      'goToNextHit',  //use mousedown to prevent input from losing focus (w/e.prevent default), click is too late
        'mousedown @ui.prevBtn':      'goToPrevHit',
        'mousedown @ui.grepBtn':      'onGrepBtnMouseDown'
    },
    onRender: function() {
        this.ui.navWr.unselectable();
        util.isIE8() && this.ui.searchBar.addClass('ie8');
        this.initialSearchTxt && this._setSearchTxt(this.initialSearchTxt);
        this.includeGrep && this.startInGrepMode && this.searchUI.set('grepMode', true, {fromRender: true});
    },
    _setSearchTxt: function(txt) {
        this.ui.searchBar.focus(); // want the event caught (even though won't occur b/c not yet in DOM; OTHERWISE localSearchText not set!!! -- (prob better way to handle) -- can't focus b/c may not yet be in DOM
        this.searchBarFocused();
        this.includeNAV && this.onKeyPressed(txt); //trigger the keyup action -- setting the searchText
    },
    serializeData: function() {
        return _.pick(this, 'placeHolder', 'includeNAV', 'includeGrep', 'initialSearchTxt', 'stretchToContainer');
    },
    searchBarFocused: function() {

        this.expand();

        var self = this;

        this.ui.searchBar.on( 'keyup', function(e) {
            
            e.stopPropagation(); //don't want picked up by doc
            
            /* check for escape key press */
            var key = e.keyCode ? e.keyCode : e.which;
            if (key === 27)  {
                self.collapseIfAllowed();    
                return; 
            }

            /* only run the action if the value changed -- DVBC-1084) */
            var searchValue = $(e.target).val();
                //don't run if the value doesn't change; former necessary to prevent error if not nav (search ui wouldn't exist)
            if (self.includeNAV && searchValue === self.searchUI.get('searchText')) return;
           
            // Delay before search in the case of typing
            if (keyUpTimer) clearTimeout(keyUpTimer);

            // start new timeout
            keyUpTimer = setTimeout(function () {
                self.onKeyPressed(searchValue);
            }, self.TIMER_DELAY);

        });

        this.onAfterFocus && this.onAfterFocus();
    },
    searchBarBlurred: function() {
        this.ui.searchBar.off('keyup');
    },
    onKeyPressed: function(searchText) {

        if (this.includeNAV) {

            var searchTxtExists = searchText.length > 0;
            this.$el.toggleClass('searchEntered', searchTxtExists);

            if (!this.searchUI.get('grepMode')) {
                this.$domToHighlight
                    .unhighlight()
                    .highlight(searchText);
                this.searchUI.set({searchText: searchText}); //perf boost w/out bbmodel change?
                this.keyUp && this.keyUp(searchText); //this will ensure state is up to date; in case there is no activeHitHighlightCallback

            } else {
                this.searchUI.set({searchText: searchText}, {silent: true});
                this.onAfterKeyUpInGrepMode && this.onAfterKeyUpInGrepMode(searchText);
            }

        } else {
            this.keyUp && this.keyUp(searchText);
        }

    },
    expand: function() {
        this.ui.searchBar.css('width', '100%');
        this.$el.addClass('open');
    },
    collapse: function() {

        if (this.includeNAV) {

            this.searchUI.set('searchText', '', {silent: true}); //ENSURE THE TEXT IS CLEARED! (if not, could be incorrect onContentReset [from ES grep mode])
            this.includeGrep && this.searchUI.set('grepMode', false);

        } 

        var $searchBar = this.ui.searchBar,
            self = this;

        this.$el.removeClass('open searchEntered');
        this.ui.searchBar.off('keyup');

        //clear the value and do b/f selection of active hit; 
        //val changes the window selection and thus breaks the functionality when this is entered through pressing escape
        //(unsure why clicking has no impact ... presumably due to timers ... )
        $searchBar.val('');

        if (this.includeNAV) {

             //place indicator on the active hit to know to select, b/c unhighlight will remove span from DOM 
              var $activeHit = this.searchUI.getActiveHit(),
                    activeHitExists = $activeHit.length > 0;

                if (activeHitExists) $activeHit.wrap($('<span class="ftTemp">'));


                this.$domToHighlight.unhighlight();

                if (activeHitExists) {

                    var $temp = this.$domToHighlight.find('.ftTemp').selectAll();

                    setTimeout(function() {
                        //replace temp with just the text(and remove highlight)
                        //check first in case content was replaced
                        try {
                            $temp.length > 0 && ( $temp[0].outerHTML = $temp.text() );
                        } catch(e) {
                            $.noop();
                        }

                    }, 3000);
                }

          }

        this.preCollapse && this.preCollapse( this.ui.searchBar.val() );
 
        $searchBar
            .css('width', this.originalWidth)
            .on('focus', _.bind(self.expand, self))
            .blur();
    },
    collapseIfAllowed: function() { //called except for force event
        this.allowCollapse && this.collapse();
    },
    onToggleCollapseAbility: function() {
        this.allowCollapse = !this.allowCollapse;
        return this;
    },
    onForceClose: function() {
        this.collapse();
        return this;
    },

    onToggleEnabled: function(turnOn) {

        turnOn
            ? this.ui.searchBar.removeAttr('disabled')
            : this.ui.searchBar.attr('disabled', 'disabled');

        return this;

    },

    activeHitChangeCB: function($activeHit) {
       //(only for those tracking hits -- todo: sep out, extended the base
        if (this.includeNAV) {
            
            var searchUI = this.searchUI,
                $hits = this.$domToHighlight.find('.highlight'), //gets the new highlights
                activeHitExists = $activeHit.length > 0;

            this.ui.totalHits.text( searchUI.get('numHits') );
            this.ui.currentHit.text( activeHitExists ? searchUI.get('activeHitIndex') + 1 : 0 );

            if (activeHitExists) {
                var $prevHit = $hits.eq(searchUI.previous('activeHitIndex'));
                ($prevHit.length > 0 && $prevHit !== $activeHit) && $prevHit.removeClass('sbActive');
                $activeHit.addClass('sbActive');
            }
            this.onAfterHighlightActiveHit && this.onAfterHighlightActiveHit($activeHit);
            
        }
    },
    onGrepBtnMouseDown: function(e) {
        e.preventDefault();   //prevent search bar from losing focus
        this.searchUI.toggleGrepMode();
    },
    goToNextHit: function(e) {
        e.preventDefault(); //prevent search bar from losing focus
        this.searchUI.goToNextOrPrevHit('next');
    },
    goToPrevHit: function(e) {
        e.preventDefault();  //prevent search bar from losing focus
        this.searchUI.goToNextOrPrevHit('previous');
    },
    onBeforeGrep: function() {
        //TODO:
    },
    //(will also highlight the active hit (if exists)
    onContentReset: function($searchContainer, highlightHitIndex) {

        this.$domToHighlight = $searchContainer;
        this.searchUI.$domElementsToSearch = $searchContainer; //(the state isn't destroyed in between)
        this.searchUI._wireEvents();

        var txt = this.searchUI.get('searchText');

        this.$domToHighlight.highlight(txt);

        this.searchUI.resetFromContentChange();

        //if from click of highlight (exiting) -- change the active hit to go to the one clicked
        //DVBC-1284: latter predicate b/c it can be 0 if its the first hit!
        (highlightHitIndex || highlightHitIndex === 0) && this.searchUI.set('activeHitIndex', highlightHitIndex, {silent: true});

        //(this will go to the active hit)
        this.searchUI.set('searchText', '', {silent: true});
        this.searchUI.set('searchText', txt);

        //(if coming back from click of local hit)
        //DVBC-1284: latter predicate b/c it can be 0 if its the first hit!
        if (highlightHitIndex || highlightHitIndex === 0) {
            //(for a trigger to turn off)
            this.searchUI.set('grepMode', null, {silent: true});
            this.searchUI.set('grepMode', false, {fromHitHighlight: true});
            this.ui.searchBar.focus(); //leave focus on the input field
        }
    },

    onSetSearchText: function(txt) {
       //i think this is all needed, event with grep, etc
        // do nothing if its the same txt that currently exists
        if (txt === this.searchUI.get('searchText')) return;
         //reset hit index in case wasn't on the first -- the first hit (if any exist, should be the active)
        this.searchUI.set({activeHitIndex: 0}, {silent: true}); 
        this.ui.searchBar.val(txt);
        this._setSearchTxt(txt);
    },

    grepModeToggled: function(m, mode, options) {
        this.ui.grepBtn
          .toggleClass('active', mode)
          .attr('title', mode ? 'Show all lines' : 'Only show lines with hits');

        !options.fromHitHighlight && !options.fromRender &&
            this.onToggleGrep && this.onToggleGrep( mode, this.searchUI.get('searchText') );
    },
    onBeforeDestroy: function() {
        this.ui.searchBar.off();
        this.searchUI && this.searchUI.destroy(); //todo -- would be part of extended view
        this.$domToHighlight && this.$domToHighlight.remove();
    }
});


//TODO: common $fn for hit nav. see search results full text
var SearchHitsUIModel = Backbone.Model.extend({
    $domElementsToSearch: null, //all a jquery object -- don't make a prop for mem cleanup (WAS BIGGEST BOTTLENECK IN MEM LEAK DELETED ES PAGE VIEW
    defaults: {
        numHits: 0,
        searchText: '',
        activeHitIndex: 0, //!don't use -1; start highlighting at the first hit
        highlightSelector: '.highlight',
        grepMode: false
    },
    initialize: function(attrs, options) {
        this.$domElementsToSearch = options.$domElementsToSearch;
        this._wireEvents();
    },
    toggleGrepMode: function(force) {
        this.set('grepMode', !this.get('grepMode'));
    },
    resetFromContentChange: function() {
        this.set({
            numHits: 0,
            searchText: ''
           // DON'T RESET THIS activeHitIndex, if one was activated, reactivate (and scroll to it)
        }, {silent: true});
    },
    _wireEvents: function() {
        this.listenTo(this, 'change:searchText', this.textSearchChange);
    },
    textSearchChange: function(me, text) {
        
        var $hits = this.$getHits(),
            $activeHit = $hits.eq(this.get('activeHitIndex'));
        
        this.set({
            searchText: text,
            numHits: $hits.length,
            activeHitIndex: $activeHit.length > 0 ? $hits.index($activeHit) : 0 //use 0, not minus one
        });
        this.trigger('changeHit', $activeHit);
    },
    $getHits: function() {
        return this.$domElementsToSearch.find( this.get('highlightSelector') );
    },
    getActiveHit: function() {
      return this.$getHits().eq( this.get('activeHitIndex') );

    },
    goToNextOrPrevHit: function(nextOrPrevious) {
        var goNext = nextOrPrevious === 'next';
        if ( this.get('activeHitIndex') === ( goNext ? this.get('numHits') - 1 : 0 ) )  return;
        var $hits = this.$getHits(),
            curIndex = this.get('activeHitIndex'),
            $goToHit = $hits.eq( curIndex + (goNext ? 1 : -1) );
        this.set({ activeHitIndex: curIndex + (goNext ? 1 : -1) });
        this.trigger('changeHit', $goToHit);
    },
    destroy: function() {
        if (this.$domElementsToSearch) {
            this.$domElementsToSearch.remove();
            this.$domElementsToSearch = null;
        }
        this.stopListening();
    }
});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/searchBar/searchBar.js
 ** module id = 497
 ** module chunks = 0
 **/